import {
  HCAPTCHA_SITE_KEY_DEV,
  HCAPTCHA_SITE_KEY_PROD,
  PROD_DOMAINS_FOR_CAPTCHA,
} from 'constants/config';
import { windowUtils } from 'utils/windowUtils/windowUtils';

const getDomainName = () => {
  const hostName = windowUtils.getHostname();
  return hostName.substring(
    hostName.lastIndexOf('.', hostName.lastIndexOf('.') - 1) + 1,
  );
};

export const captchaKey = (() => {
  const domainName = getDomainName();
  return PROD_DOMAINS_FOR_CAPTCHA.includes(domainName)
    ? HCAPTCHA_SITE_KEY_PROD
    : HCAPTCHA_SITE_KEY_DEV;
})();
